module.exports = __webpack_public_path__ + "img/folios--avatar.1c404fc7.svg";